"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allOrderLinesCancelled = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const allOrderLinesCancelled = (order) => {
    if (!order)
        return false;
    if (!order.order_lines)
        return false;
    const line_statuses = order.order_lines.map((line) => {
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return "UNKNOWN";
        return latest_version.status;
    });
    const cancelled_statuses = line_statuses.filter((x) => {
        return x.includes("CANCELLED");
    });
    return line_statuses.length === cancelled_statuses.length;
};
exports.allOrderLinesCancelled = allOrderLinesCancelled;
